import React, {useCallback, useRef, useState} from 'react'

import EntitySelectorSearch from "../../search/search"
import EntitySelectorProjectsList from "./list"

// const debug = "EntitySelectorProjects"
const debug = false

// One view, no sub-tabs: the tree IS both the browse and the search surface --
// a query prunes it rather than replacing it with a list.
export default function EntitySelectorProjects () {

    const [search, setSearch]   = useState('')
    const listRef               = useRef<any>()

    const onSearchChanged = useCallback((search:string)=>{
        setSearch(search)
    }, [])

    const onKeyDown = useCallback((event: any)=>{
        listRef.current?.onKeyDown(event)
    }, [])

    debug && console.log(debug, 'render', search)

    return (
        <>
            <EntitySelectorSearch
                onKeyDown       = {onKeyDown}
                onSearchChanged = {onSearchChanged}
            />

            <EntitySelectorProjectsList
                ref     = {listRef}
                search  = {search}
            />
        </>
    )
}
